import { BaseService } from "../base.service";

export default class TokenService extends BaseService {
  constructor() {
    super();
  }

  async getAccessToken(didToken: string) {
    const resp = await this.client.post(
      "/super/identity/token",
      {},
      {
        headers: { Authorization: `Bearer ${didToken}` },
      }
    );
    return resp.data.accessToken;
  }
}
